import {DATA_ACCESS_TOKEN, TIMEOUT} from '../constants/constants';
import {Modal} from "antd/lib/index";
import Fingerprint2 from 'fingerprintjs2';

export const request = (options, skipErrorCodes) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(DATA_ACCESS_TOKEN)) {
        headers.append('Authorization', localStorage.getItem(DATA_ACCESS_TOKEN))
    }

    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);

    return timeout(fetch(options.url, options))
        .then(response => {
            if (!response.ok) {
                return processErrors(response, skipErrorCodes);
            }
            return response.json()
                .then(json => {
                    return json;
                })
        })
        .catch(error => {
            processErrors(error, skipErrorCodes);
        });
};

export const run = (options, skipErrorCodes) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(DATA_ACCESS_TOKEN)) {
        headers.append('Authorization', localStorage.getItem(DATA_ACCESS_TOKEN))
    }

    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);

    return timeout(fetch(options.url, options)).catch(error => {
        processErrors(error, skipErrorCodes);
    });
};

export const download = (options, skipErrorCodes) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(DATA_ACCESS_TOKEN)) {
        headers.append('Authorization', localStorage.getItem(DATA_ACCESS_TOKEN))
    }

    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);

    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    return timeout(fetch(options.url, options))
        .then(response => {
            if (!response.ok) {
                return processErrors(response, skipErrorCodes);
            }
            return response.blob().then(blob => {
                let urlObject = window.URL.createObjectURL(blob);
                a.href = urlObject;
                a.download = options.fileName;
                a.click();
                window.URL.revokeObjectURL(urlObject);
                return blob;
            })
        })
        .catch(error => {
            processErrors(error, skipErrorCodes);
        });
};

export function getFiltersAsQuery(filters) {
    let query = '';
    if (filters !== undefined) {
        query = Object.keys(filters)
            .filter(key => filters[key])
            .filter(key => filters[key].length > 0)
            .map(key => filters[key].map(item => key + ':' + item + '*').join(" OR "))
            .join(" AND ");
    }
    return query;
}

export function showError(content, title = 'Error') {
    Modal.error({
        title: title,
        content: content
    });
}

export function showInfo(content, title = 'Información', keyboard = true, onOk = {}) {
    Modal.info({
        title: title,
        content: content,
        keyboard: keyboard,
        onOk: onOk
    });
}

export function showInformation(title, content) {
    Modal.info({
        title: title,
        content: content
    });
}

export function getFingerPrint() {
    const options = {
        excludes: {
            screenResolution: true,
            availableScreenResolution: true,
            webgl: true,
            canvas: true,
            pixelRatio: true,
            enumerateDevices: true,
            hasLiedBrowser: true,
            hasLiedOs: true,
            hasLiedResolution: true,
            hasLiedLanguages: true,
            adBlock: true,
            audio: true,
            fontsFlash: true,
            touchSupport: true,
            plugins: true,
            fonts: true
        },
        extraComponents: [
            {
                key: 'countryName', getData: function (done, options) {
                    done(" ");
                }
            }
        ]
    };

    return new Promise(function (resolve, reject) {
        Fingerprint2.get(options, function (components) {
            const values = components.map(function (component) {
                return component.value
            });
            const hash = Fingerprint2.x64hash128(values.join(''), 31);

            let componentMap = {};
            components.map(component => {
                return componentMap[component.key] = component.value;
            });

            resolve({
                'hash': hash,
                'data': componentMap
            });
        });
    });
}

export function getAvatarColor(name) {
    name = name.substring(0, 6);

    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = 31 * hash + name.charCodeAt(i);
    }
    const index = Math.abs(hash % colors.length);
    return colors[index];
}

export function isArrayEmpty(arr) {
    return arr === undefined || arr.length === 0;
}

export function removeFromArray(arr, value) {
    const index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
    }
}

/*************************************************************/
/******************** private ********************************/
/*************************************************************/
function processErrors(error, skipErrorCodes) {
    if (error.status === 401 && !skipErrorCodes.includes(401)) {
        window.app.handleLogout();
    } else if (error.status === 403 && !skipErrorCodes.includes(403)) {
        showError('Usted no tiene acceso a este recurso. Intente autenticarse nuevamente')
    } else if (error.status === 500 && !skipErrorCodes.includes(500)) {
        showError('Algo ha fallado en el servidor. ' + error.message)
    } else {
        throw error;
    }
}

function timeout(promise, time = TIMEOUT) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            reject(new Error("timeout"))
        }, time);
        promise.then(resolve, reject)
    })
}

const colors = [
    '#F44336', '#e91e63', '#9c27b0', '#673ab7',
    '#ff9800', '#ff5722', '#795548', '#607d8b',
    '#3f51b5', '#2196F3', '#00bcd4', '#009688',
    '#2196F3', '#32c787', '#00BCD4', '#ff5652',
    '#ffc107', '#ff85af', '#FF9800', '#39bbb0',
    '#4CAF50', '#ffeb3b', '#ffc107',
];


// WEBPACK FOOTER //
// ./src/app/services/APIService.js